import React from 'react';

/**
 * ATC VR Center 랜딩
 * VR 투어는 /ATCVRCENTER/ATC/omron_vr.html 에서 제공
 */
const Home: React.FC = () => {
	const vrUrl = '/ATCVRCENTER/ATC/omron_vr.html';

	const openVrPopup = () => {
		const width = 1920;
		const height = 1080;
		const left = Math.max(0, (window.screen.width - width) / 2);
		const top = Math.max(0, (window.screen.height - height) / 2);
		window.open(
			vrUrl,
			'OmronVR',
			`width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=no`
		);
	};

	return (
		<div style={{
			minHeight: '100vh',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			padding: 24,
			boxSizing: 'border-box',
			fontFamily: 'Pretendard, sans-serif',
			background: '#f5f5f5',
		}}>
			<h1 style={{ marginBottom: 8, fontSize: '1.5rem', color: '#333' }}>
				OMRON Automation Center
			</h1>
			<p style={{ marginBottom: 24, color: '#666', fontSize: '0.95rem' }}>
				가상 투어를 통해 오므론 오토메이션 센터를 둘러보세요.
			</p>
			<button
				type="button"
				onClick={openVrPopup}
				style={{
					padding: '12px 24px',
					fontSize: '1rem',
					fontWeight: 600,
					color: '#fff',
					backgroundColor: '#e60012',
					border: 'none',
					borderRadius: 6,
					cursor: 'pointer',
				}}
			>
				VR 투어 열기
			</button>
			<p style={{ marginTop: 16, fontSize: '0.85rem', color: '#999' }}>
				<a href={vrUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#0066cc' }}>
					새 탭에서 열기
				</a>
			</p>
		</div>
	);
};

export default Home;
